enum OrderImageType {
  Qr = 1,
  BarCode = 2,
}

export default OrderImageType;
